import initIndex from './utilities/algoliaInitIndex'
import createFilter from './utilities/algoliaCreateFilter'

const usersIndex = initIndex('users')

// Response from Algolia, ref: https://www.algolia.com/doc/api-reference/api-methods/search/#response-format

//	Note: we only ever get userNames and fillName back from algolia
const algoliaSearchUser = async ({ query, facets }) => usersIndex.search({
	query,
	filters: createFilter(facets),
	hitsPerPage: 24,
	page: 0,
	//  Highlighting not required
	attributesToHighlight: []
}).catch((error) => { //  TODO: Add to error types/messages
	console.log('ALGOLIA ERROR', error)
	return { error, query }
})

export default algoliaSearchUser



// WEBPACK FOOTER //
// ./src/dataservices/algoliaSearchUser.js